import * as actions from "../../../../Config/ApiUrl.js";

const configTable = {
    name: 'AdvanceTable',
    enableRowSelect : true,
    url: actions.COSTINGRESOURCES,
    showHeader: true,
    enableHighlights: true,
    enableSaveFilter: true,
    columns: [], 
    actions: [
        {
            title: 'Print',
            icon: 'printer',
            type: 'none',
        },
        {
            title: 'View',
            icon: 'eye',
            type: 'none',
        },
        {
            title: "Edit",
            icon: 'edit',
            type: 'none',
        },
        {
            title: "Revision",
            icon: 'file-text',  // 👈
            type: 'none',
        },
        {
            title: "Duplicate",
            icon: 'copy',
            type: 'none',
        },
        {
            title: "Delete",
            icon: 'trash',
            type: 'none',
            component: 'app-confirmation-modal',
            modalId: 'demo-delete',
        }
    ],
    filters: [
        {
            title: "Date",
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "nextYear"]
        },
        {
            title: "Buscar",
            type: "search-and-select-filter",
            key: "serverside_select",
            settings: {
                url: actions.COSTING_SEARCH_SELECT,
                modifire: (v) => ({ id: v.id, name: v.name }),
                per_page: 10,
                queryName: 'search_selectable',
                loader: 'app-pre-loader',
                multiple: true,
                params: {
                    'type': 'type1',
                    'isWanted': true
                }
            },
            listValueField: 'name'
        },
    ],
    showFilter: false,
    showSearch: true,
    showCount: true,
    showClearFilter: true,
    paginationType: "pagination",
    responsive: true,
    rowLimit: 10,
    showAction: true,
    orderBy: 'desc',
    actionType: "default",
}

export default configTable;
